import { useEffect, useRef } from 'react'

import { useAutocompleteStore, useColdStartStore } from '../store'
import DefaultSearchOption from './DefaultSearchOption'
import { useAmplitude } from '@wiggot/analytics/src/providers/amplitud-provider/AmplitudeProvider'
import useGeolocation from '@wiggot/hooks/src/useGeolocation'
import { SuggestionOriginEnum } from '../interfaces/autocomplete'
import { getZoneCoincidencesByLocation } from '../services/zoneServices'
import { GoogleMapsStructuredPlace } from '../interfaces/googleMapsInterfaces'

interface Props {
  isHidden?: boolean
  searchText: string
  selectedIndex: number
  itemClassName?: string
  itemTextClassName?: string
  focusOptionClassNames?: string
  onSelected: (place: GoogleMapsStructuredPlace) => void
}

const DefaultSearches = ({
  isHidden,
  searchText,
  selectedIndex,
  itemClassName,
  itemTextClassName,
  focusOptionClassNames,
  onSelected
}: Props) => {
  const { instance, trackEvent } = useAmplitude()

  const { getLocation } = useGeolocation()

  const { setSelectedSuggestionOrigin } = useAutocompleteStore()

  const {
    defaultSearches,
    isUsedAutocomplete,
    setDefaultSearches,
    setIsUsedAutocomplete
  } = useColdStartStore()

  const isLoading = useRef(false)

  const loadCoincidences = async (): Promise<void> => {
    const { isSuccess: isSuccessLocation, coordinates } = await getLocation()

    if (!isSuccessLocation) {
      isLoading.current = false
      return
    }

    const { latitude, longitude } = coordinates

    const { isSuccess, data } = await getZoneCoincidencesByLocation({
      latitude,
      longitude,
      deviceId: instance?.getDeviceId() ?? '',
      sessionId: instance?.getSessionId()?.toString() ?? '',
      userId: instance?.getUserId() ?? ''
    })

    if (isSuccess && data) {
      setDefaultSearches(data)
    }

    isLoading.current = false
  }

  const selectedOption = (
    palce: GoogleMapsStructuredPlace,
  ): void => {
    setSelectedSuggestionOrigin(SuggestionOriginEnum.MONOPOLIO)

    onSelected(palce)
  }

  useEffect(() => {
    if (searchText) {
      setIsUsedAutocomplete(true)
      return
    }

    if (isLoading.current || isUsedAutocomplete || defaultSearches.length) {
      return
    }

    isLoading.current = true
    loadCoincidences()
  }, [searchText, isLoading])

  if (isHidden || searchText || !defaultSearches.length || isUsedAutocomplete) {
    return <></>
  }

  return (
    <div>
      <p className="text-xs text-[#898CA8]">Ubicaciones</p>

      <div className="flex flex-col mt-2.5">
        {defaultSearches.map((item, index) => {
          return (
            <DefaultSearchOption
              key={item.id}
              index={index}
              option={item}
              selectedIndex={selectedIndex}
              itemTextClassName={itemTextClassName}
              className={itemClassName}
              focusOptionClassNames={focusOptionClassNames}
              onSelected={(place) => {
                selectedOption(place)
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

export default DefaultSearches
